import React, { FunctionComponent } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import { getHistory } from '../../app/store';
import { PublicOnlyRoute } from './PublicOnlyRoute';
import { UserOnlyRoute } from './UserOnlyRoute';
import { AdminOnlyRoute } from './AdminOnlyRoute';
import { LoginPage } from '../pages/LoginPage';
import { SignUpPage } from '../pages/SignUpPage';
import { HomePage } from '../pages/HomePage';
import { MeetingPage } from '../pages/MeetingPage';
import { LiveMeetingPage } from '../pages/LiveMeetingPage';
import { UserPage } from '../pages/UserPage';
import { MeetingDashboardPage } from '../pages/MeetingDashboardPage';
import { KpiPage } from '../pages/KpiPage';
import { VtoPage } from '../pages/VtoPage';
import { ChartPage } from '../pages/ChartPage';
import { ChartEditPage } from '../pages/ChartEditPage';
import { PasswordsPage } from '../pages/PasswordsPage';
import { TimeTrackingPage } from '../pages/TimeTrackingPage';
import { QuartalsPage } from '../pages/QuartalsPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { AgencyToolsPage } from '../pages/AgencyToolsPage';
import { AgencyDashboardPage } from '../pages/AgencyDashboardPage';
import { AgencySinglePage } from '../pages/AgencySinglePage';
import { NotFound } from '../pages/ErrorPages/NotFound';
import { BasicInfoPage } from '../pages/SettingsPage/Profile/pages/BasicInfoPage';
import { NotificationsPage } from '../pages/SettingsPage/Profile/pages/NotificationsPage';
import { SecurityPage } from '../pages/SettingsPage/Profile/pages/SecurityPage';
import { SignUpSuccessScreen } from '../pages/SignUpSuccessScreen';
import { GeneralPage } from '../pages/SettingsPage/General';
import { AnnualAndPeriodsPage } from '../pages/SettingsPage/General/pages/AnnualAndPeriodsPage';
import { GeneralSettingsPage } from '../pages/SettingsPage/General/pages/GeneralSettingsPage';
import { IntegrationsPage } from '../pages/SettingsPage/General/pages/IntegrationsPage';
import { CurrentPlanPage } from '../pages/SettingsPage/Subscription/pages/CurrentPlanPage';
import { PaymentsPage } from '../pages/SettingsPage/Subscription/pages/PaymentsPage';
import { InvoicesPage } from '../pages/SettingsPage/Subscription/pages/InvoicesPage';
import { PaymentMethodsPage } from '../pages/SettingsPage/Subscription/pages/PaymentMethodsPage';
import { BillingInfoPage } from '../pages/SettingsPage/Subscription/pages/BillingInfoPage';
import { InvoiceDetailPage } from '../pages/InvoiceDetailPage';
import { ArchivePage } from '../pages/ArchivePage';
import { WorkspaceSelectionPage } from '../pages/WorkspaceSelectionPage';
import { SetPasswordPage } from '../pages/SetUpPassword';
import MeetingMemberReportsPage from '../pages/ReportsPages/MeetingMemberReportPage';
import MeetingTeamReportsPage from '../pages/ReportsPages/MeetingTeamReportsPage';
import UserReportsPage from '../pages/ReportsPages/UserReportPage';
import MeetingTranscriptPage from '../pages/MeetingTranscriptPage';
import { CompanyVisionPage } from '../pages/CompanyVisionPage';
import { OAuthConsentPage } from '../pages/OAuthConsentPage';
export const Router: FunctionComponent = () => (
  <ConnectedRouter history={getHistory()}>
    <Switch>
      <PublicOnlyRoute exact path="/forgotpassword" component={ForgotPasswordPage} />
      <PublicOnlyRoute exact path="/set-password" component={SetPasswordPage} />
      <PublicOnlyRoute exact path="/login" component={LoginPage} />
      <PublicOnlyRoute exact path="/sign-up" component={SignUpPage} />
      <PublicOnlyRoute exact path="/sign-up-success" component={SignUpSuccessScreen} />
      <UserOnlyRoute exact path="/workspaces" component={WorkspaceSelectionPage} />
      <UserOnlyRoute exact path="/" component={HomePage} />
      <UserOnlyRoute exact path="/oauth/consent" component={OAuthConsentPage} />
      <UserOnlyRoute exact path="/home" component={HomePage} />
      <UserOnlyRoute exact path="/directory" component={UserPage} />
      <UserOnlyRoute exact path="/task-preview/:taskId" component={HomePage} />
      <UserOnlyRoute exact path="/passwords/:meetingId" component={PasswordsPage} />
      <UserOnlyRoute exact path="/accounts" component={() => <MeetingPage type="account" />} />
      <UserOnlyRoute exact path="/meetings" component={() => <MeetingPage type="meeting" />} />
      <UserOnlyRoute exact path="/meeting-dashboard/:meetingId/:meetingName" component={MeetingDashboardPage} />
      <UserOnlyRoute exact path="/reports/meetings/:meetingId/:meetingName" component={MeetingTeamReportsPage} />
      <UserOnlyRoute
        exact
        path="/reports/meetings/:meetingId/:meetingName/users/:memberId"
        component={MeetingMemberReportsPage}
      />
      <UserOnlyRoute exact path="/reports/users/:userId" component={UserReportsPage} />
      <UserOnlyRoute exact path="/kpi/:meetingId" component={KpiPage} />
      <UserOnlyRoute exact path="/meeting-archives/:sessionId" component={ArchivePage} />
      <UserOnlyRoute exact path="/meetings/:meetingId/transcripts/:sessionId" component={MeetingTranscriptPage} />
      <UserOnlyRoute exact path="/live-meeting/:meetingId/:sessionId" component={LiveMeetingPage} />
      <UserOnlyRoute exact path="/agency-tools" component={AgencyToolsPage} />
      <UserOnlyRoute exact path="/agency-tools/context/:companyContextId/edit" component={CompanyVisionPage} />
      <UserOnlyRoute exact path="/agency-tools/context/:companyContextId" component={CompanyVisionPage} />
      <UserOnlyRoute exact path="/agency-dashboard/:itemId" component={AgencyDashboardPage} />
      <UserOnlyRoute exact path="/agency-single/:columnId" component={AgencySinglePage} />
      <UserOnlyRoute exact path="/vto" component={VtoPage} />
      <UserOnlyRoute exact path="/chart" component={ChartPage} />
      <AdminOnlyRoute exact path="/chart/edit" component={ChartEditPage} />
      <UserOnlyRoute exact path="/time-tracking" component={TimeTrackingPage} />
      <UserOnlyRoute exact path="/quartals" component={QuartalsPage} />
      <AdminOnlyRoute exact path="/settings/administration" component={GeneralPage} />
      <AdminOnlyRoute exact path="/settings/administration/annuals-and-periods" component={AnnualAndPeriodsPage} />
      <AdminOnlyRoute exact path="/settings/administration/general-settings" component={GeneralSettingsPage} />
      <AdminOnlyRoute exact path="/settings/administration/integrations" component={IntegrationsPage} />
      <AdminOnlyRoute exact path="/settings/subscription" component={CurrentPlanPage} />
      <AdminOnlyRoute exact path="/settings/subscription/current-plan" component={CurrentPlanPage} />
      <AdminOnlyRoute exact path="/settings/subscription/payments" component={PaymentsPage} />
      <AdminOnlyRoute exact path="/settings/subscription/invoices" component={InvoicesPage} />
      <AdminOnlyRoute exact path="/settings/subscription/payment-methods" component={PaymentMethodsPage} />
      <AdminOnlyRoute exact path="/settings/subscription/billing-info" component={BillingInfoPage} />
      <AdminOnlyRoute exact path="/settings/subscription/invoices/:id" component={InvoiceDetailPage} />
      <UserOnlyRoute exact path="/settings/profile" component={BasicInfoPage} />
      <UserOnlyRoute exact path="/settings/profile/basic-info" component={BasicInfoPage} />
      <UserOnlyRoute exact path="/settings/profile/notifications" component={NotificationsPage} />
      <UserOnlyRoute exact path="/settings/profile/security" component={SecurityPage} />
      <Route component={NotFound} />
    </Switch>
  </ConnectedRouter>
);
